import React from 'react'
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Paper,
    Typography
} from '@mui/material/';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ImportarImagen from '../../Functions/ImportarImagen';


const ModalImagen = (props) => {
    const {
        id,
        setMostrarImagen,
        mostrarImagen,
        nodos,
        setNodos,
        abrirModalImagen,
        handleCloseModalImage, 
    } = props;

    return (
        <Dialog
            open={abrirModalImagen}
            onClose={handleCloseModalImage}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
        >
            <DialogContent>
                <Typography
                    variant="h4"
                    align='center'
                    sx={{
                        marginBottom: '20px',
                        fontWeight: 'bold'
                    }}
                >
                    Importar Imagen
                </Typography>
                
                <Paper 
                    component="form"
                    style={{color: 'red'}}
                    sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: 400
                    }}    
                >
                    <ImportarImagen
                        id={id}
                        setMostrarImagen={setMostrarImagen}
                        mostrarImagen={mostrarImagen}
                        nodos={nodos}
                        setNodos={setNodos}
                        handleCloseModalImage={handleCloseModalImage}
                    />
                </Paper>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleCloseModalImage}>
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalImagen